<template>
  <transition name="dialog-fade">
    <div
      v-if="visible"
      class="custom-dialog__wrapper"
      @click.self="handleClose"
    >
      <div class="custom-dialog" :style="{ width, height }">
        <!-- 头部区域 -->
        <div class="custom-dialog__header">
          <div class="header-left">
            <span class="title-icon">!</span>
            <span class="title-text">{{ title || '提示' }}</span>
          </div>
          <button class="close-btn" @click="handleClose">
            <span class="close-icon">×</span>
          </button>
        </div>

        <!-- 内容区域 -->
        <div class="custom-dialog__body">
          <slot>
            <div v-if="content" class="default-content">
              <img v-if="icon" :src="icon" class="content-icon" />
              <p>{{ content }}</p>
            </div>
          </slot>
        </div>

        <!-- 底部按钮 -->
        <div class="custom-dialog__footer">
          <button
            v-if="showCancel"
            class="custom-btn cancel-btn"
            @click="handleCancel"
          >
            {{ cancelText || '取消' }}
          </button>
          <button class="custom-btn confirm-btn" @click="handleConfirm">
            {{ okText || '确认' }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CustomDialog',
  // 支持 Vue2 v-model 绑定到 visible
  model: {
    prop: 'visible',
    event: 'input',
  },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '提示' },
    content: { type: String, default: '' },
    width: { type: String, default: '500px' },
    height: { type: String, default: 'auto' },
    okText: { type: String, default: '确认' },
    cancelText: { type: String, default: '取消' },
    showCancel: { type: Boolean, default: true },
    icon: { type: String, default: '' },
    closeOnClickModal: { type: Boolean, default: true },
  },
  methods: {
    handleClose() {
      if (this.closeOnClickModal) {
        this.$emit('input', false)
        this.$emit('close')
      }
    },
    handleCancel() {
      this.$emit('input', false)
      this.$emit('cancel')
    },
    handleConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.custom-dialog__wrapper {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
}

.custom-dialog {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}

.custom-dialog__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.title-icon {
  width: 32px;
  height: 32px;
  background: #0f8dff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
}
.title-text {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
}
.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background 0.3s;
}
.close-btn:hover {
  background: #f5f7fa;
}
.close-icon {
  font-size: 24px;
  color: #718096;
}

.custom-dialog__body {
  padding: 28px 24px;
  flex: 1;
  overflow-y: auto;
  color: #4a5568;
  line-height: 1.6;
}
.default-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.content-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
}
.default-content p {
  font-size: 16px;
  max-width: 90%;
}

.custom-dialog__footer {
  padding: 16px 24px;
  background: #f8f9fa;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
.custom-btn {
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  border: none;
  transition: all 0.3s;
}
.cancel-btn {
  background-color: #f1f5f9;
  color: #64748b;
  border: 1px solid #cbd5e1;
}
.cancel-btn:hover {
  background-color: #e2e8f0;
  border-color: #94a3b8;
}
.confirm-btn {
  background: linear-gradient(135deg, #0f8dff, #0b76e0);
  color: #fff;
  box-shadow: 0 4px 6px rgba(15, 141, 255, 0.2);
}
.confirm-btn:hover {
  background: linear-gradient(135deg, #0b76e0, #0962b8);
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(15, 141, 255, 0.3);
}
.confirm-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(15, 141, 255, 0.2);
}

/* 动画 */
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.dialog-fade-enter,
.dialog-fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
